module.exports = __webpack_public_path__ + "media/categories/7020-f47460fe.svg";